import { Container } from "./Styled";

const Button = (props: any) => {
  return <Container {...props}/>
};

export default Button;
